export const ACTIVE_FINALIZADO_TRAMITACAO_MESSAGE =
  'Já existe uma tramitação interna ativa com status Finalizado. Apenas uma etapa Finalizado pode estar ativa por vez.';

type TramitacaoInternaStep = {
  id?: number;
  ativo?: boolean;
  status?: string;
};

export function hasOtherActiveFinalizadoStep(
  processes: TramitacaoInternaStep[],
  excludeId?: number,
): boolean {
  return processes.some(
    (step) =>
      step.ativo === true &&
      step.status === 'Finalizado' &&
      step.id !== excludeId,
  );
}

export function wouldViolateActiveFinalizadoRule(
  processes: TramitacaoInternaStep[],
  ativo: boolean,
  status?: string,
  excludeId?: number,
): boolean {
  return (
    ativo === true &&
    status === 'Finalizado' &&
    hasOtherActiveFinalizadoStep(processes, excludeId)
  );
}
